import * as React from 'react';
export const truckSvg = React.forwardRef(function truckSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.45 12a2.5 2.5 0 1 1-4.89-.049A2 2 0 0 1 0 10V3a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1h2.172a2 2 0 0 1 1.414.586l1.828 1.828A2 2 0 0 1 16 7.828V11a1 1 0 0 1-1 1h-.55a2.5 2.5 0 1 1-4.9 0h-3.1ZM2 2.5h6a.5.5 0 0 1 .5.5v7.5H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5Zm9.134 9.5a1 1 0 1 0 1.733 0h-1.733Zm-6.268 0H3.134a1 1 0 1 0 1.732 0ZM10 10.5h4.5V7.828a.5.5 0 0 0-.146-.353l-1.829-1.829a.5.5 0 0 0-.353-.146H10v5Z',
    }),
  );
});
truckSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var truck = {
  category: 'icon',
  colorable: true,
  name: 'truck',
  svg: truckSvg,
};
